export default "__VITE_ASSET__BqbHty0___"